/* unplugin-vue-components disabled */import script from "./RegisterViewer.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterViewer.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterViewer.vue?vue&type=style&index=0&id=cadbc4ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cadbc4ea"]])

export default __exports__